import React, { useMemo } from 'react';
import BoxContainer from 'components/BoxContainer';
import styles from './styles.module.less';
import PortalTable from '../components/PortalTable';
import useGetCorporations from 'packages/utils/hooks/workDirection/useGetCorporations';

const normalizeRut = s => String(s ?? '').toLowerCase().replace(/[.\-\s]/g, '');

export default function Portal() {
  const [queryText, setQueryText] = React.useState('');
  const { data: corporations, loading } = useGetCorporations({ runFirstTime: true });

  const dataFiltered = useMemo(() => {
    let output = [];
    if (!queryText) output = corporations;
    else {
      const q = queryText.toLowerCase();
      const qRut = normalizeRut(queryText);
      output = corporations.filter(({ name = '', RUT = '' }) => {
        if (name.toLowerCase().includes(q)) return true;
        if (!RUT) return false;
        return normalizeRut(RUT).includes(qRut);
      });
    }
    // sort alphabetically by name
    output.sort((a, b) => a.name.localeCompare(b.name));
    return output;
  }, [corporations, queryText]);

  return (
    <BoxContainer>
      <BoxContainer content>
        <div className={styles.main}>
          <div className={styles.container}>
            <div className={styles.content}>
              <div className={styles.tableContainer}>
                <PortalTable data={dataFiltered} loading={loading} onSearch={setQueryText} />
              </div>
            </div>
          </div>
        </div>
      </BoxContainer>
    </BoxContainer>
  );
}
